import React from 'react';
import { DatePicker as AntDatePicker } from 'antd';
import styled from 'styled-components';
import { IconCalendar, IconClose } from '../Icons';

const StyledDatePicker = styled(AntDatePicker)`
  &.ant-picker {
    width: 100%;

    &.ant-picker-disabled,
    &.ant-picker-disabled input[disabled] {
      border-color: var(--greyscale-dark-white);
      cursor: default;

      &:hover {
        border-color: var(--greyscale-dark-white);
      }

      &::placeholder {
        color: var(--greyscale-concrete);
      }

      svg {
        path {
          stroke: var(--greyscale-concrete);
        }
      }
    }

    .ant-picker-input > input {
      line-height: 1;
      font-size: var(--font-size-regular);
    }

    .ant-picker-input > input:placeholder-shown {
      font-style: italic;
    }
  }
`;

const calendarIcon = <IconCalendar />;

const DatePicker = (props) => (
  <StyledDatePicker
    placeholder="TT.MM.JJJJ"
    format="DD.MM.YYYY"
    suffixIcon={calendarIcon}
    {...props}
    allowClear={{ clearIcon: <IconClose /> }}
  />
);

const DatePickerRange = (props) => (
  <StyledDatePicker.RangePicker
    format="DD.MM.YYYY"
    ranges={[]}
    separator="."
    {...props}
    allowClear={{ clearIcon: <IconClose /> }}
  />
);

export { DatePickerRange, DatePicker };
